import { createAsyncThunk } from "@reduxjs/toolkit";

import { getTeam } from "Api/teams/getTeam.request";

export const getTeamThunk = createAsyncThunk("team/getTeam", getTeam);
